// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General layout */
.spa-framework {
    display: flex;
    flex-direction: column;
    height: 100dvh; /* full viewport height (exclusing internal browser  buttons)*/
    width: 100%; /* full width */
    background: var(--color-background);
}

    .spa-framework.dark {
        background: var(--color-background);
        color: var(--color-foreground);
    }

    .spa-framework.light {
        background: var(--color-component-background);
        color: var(--color-component-foreground);
    }

    .spa-framework .spa-header > svg {
        background-color: var(--color-component-transparent-background);
        padding: 0.2rem;
        margin-left: 1rem;
        border-radius: 4px;
    }


@media (min-aspect-ratio: 13/9) { /* Very wide viewports (landscape phones) */
    .spa-framework.scrolled-down .spa-header {
        min-height: 0px;
        max-height: 0px;
        opacity: 0;
    }

    .spa-framework.scrolled-down .spa-sticky-footer {
        min-height: 0px;
        max-height: 0px;
        opacity: 0;
    }
}

.spa-framework > footer {
    flex: 0 0 auto;
    height: fit-content;
}

.spa-scroll-section-container {
    position: relative;
    display: flex;
    height: 100%;
    margin: 0.5rem;
}

.spa-scroll-section {
    flex: 1 1 auto; /* fills remaining space */
    overflow-x: hidden;
    overflow-y: auto;
    margin: 0.5rem;
}

.section-body {
    min-height: 100vh;
    width: 100%;
}

/* Header */
.spa-header {
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    height: fit-content; /* shrink to content */
    width: 100%;
    position: sticky;
    top: 0;
    z-index: 100;
    transition: opacity ease 0.5s, max-height ease 0.5s, min-height ease 0.5s, transform ease 0.5s;
}

    .spa-header > svg {
        transition: opacity 1s ease, max-width 1s ease;
    }

    .spa-header.hidden {
        min-height: 0px;
        max-height: 0px;
        opacity: 0;
    }

    .spa-header.visible {
        opacity: 1;
    }

.spa-framework > .spa-header.dark {
    background-color: var(--color-background);
    color: var(--color-foreground);
    stroke: var(--color-foreground);
    fill: var(--color-foreground);
}

.spa-framework > .spa-header.light {
    background-color: var(--color-component-background);
    color: var(--color-component-foreground);
    stroke: var(--color-component-foreground);
    fill: var(--color-component-foreground);
}

/* Footer */
.spa-footer {
    width: 100%;
    background: var(--color-footer-back);
    color: var(--color-footer-fore);
}

    .spa-footer > div {
        height: fit-content;
        min-height: 5rem;
    }


div.skitterbook-account-header > .account-header-title {
    margin-right: 0.5rem
}

span.account-header-error {
    display: none;
}

/* Mobile (<768px) */
@media (max-width: 767px) {
    .spa-header > svg {
        opacity: 0;
        max-width: 0px;
    }

    .spa-footer {
        position: relative;
    }

    /* Header hides on scroll */
    .spa-framework.scrolled-down .spa-header {
        transform: translateY(-100%);
    }

    .skitterbook-background-image-container {
    }
}

/* Desktop (>=768px) */
@media (min-width: 768px) {

    .spa-header {
        min-height: 5rem;
    }

    .skitterbook-background-image-container {
    }
}

@media (max-width: 768px) {

    .spa-header {
        min-height: 4rem;
    }

    .skitterbook-background-image-container {
    }
}

.temporary-body {
    height: 100vh;
    background-color: darkblue;
}

.scroll-down-indicator {
    position: absolute;
    bottom: 4rem;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    border-radius: 50%;
    z-index: 1;
    transition: opacity 0.5s ease;
    background: var(--color-background);
}

.scroll-up-indicator {
    position: absolute;
    top: 4rem;
    left: 50%;
    transform: translateX(-50%) rotate(180deg);
    opacity: 0;
    border-radius: 50%;
    z-index: 1;
    transition: opacity 0.5s ease;
    background: var(--color-background);
}

.spa-framework.can-scroll-down.show-scroll-indicators .scroll-down-indicator {
    opacity: 0.5;
    stroke: var(--color-background);
}

.spa-framework.can-scroll-up.show-scroll-indicators .scroll-up-indicator {
    opacity: 0.5;
    stroke: var(--color-background);
}

#framework-top-left, #framework-top-right {
    margin-top: 1rem;
    margin-left: 1rem;
}

    #framework-top-left > .dock-panel-item > * {
        width: 100%;
        height: 100%;
    }

    #framework-top-left > .dock-panel-item button {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
    }

#framework-top-right {
    width: fit-content;
}

    #framework-top-right > .dock-panel-item {
        display: flex;
        justify-content: end;
        height: fit-content;
        width: auto;
    }

.skitterbook-maker-outer-container {
    position: relative;
}

    .skitterbook-maker-outer-container > .sd-container {
        position: absolute;
        height: fit-content;
        width: fit-content;
        right: 1.5rem;
        top: 1.5rem;
    }

.skitterbook-background-image-container {
    position: absolute;
    height: 100vh;
    width: 100vw;
    z-index: -1;
}

/* Add docked gesture swipe containers are smaller */

.dock-panel-item .gesture-swipe-container {
    height: 2rem;
    width: 2rem;
}

.dock-panel-item > .skitterbook-live-print-button > span > svg {
    width: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/Container/css/SPAFramework.css"],"names":[],"mappings":"AACA,mBAAmB;AACnB;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc,EAAE,8DAA8D;IAC9E,WAAW,EAAE,eAAe;IAC5B,mCAAmC;AACvC;;IAEI;QACI,mCAAmC;QACnC,8BAA8B;IAClC;;IAEA;QACI,6CAA6C;QAC7C,wCAAwC;IAC5C;;IAEA;QACI,+DAA+D;QAC/D,eAAe;QACf,iBAAiB;QACjB,kBAAkB;IACtB;;;AAGJ,kCAAkC,2CAA2C;IACzE;QACI,eAAe;QACf,eAAe;QACf,UAAU;IACd;;IAEA;QACI,eAAe;QACf,eAAe;QACf,UAAU;IACd;AACJ;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,cAAc,EAAE,0BAA0B;IAC1C,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA,WAAW;AACX;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,mBAAmB,EAAE,sBAAsB;IAC3C,WAAW;IACX,gBAAgB;IAChB,MAAM;IACN,YAAY;IACZ,8FAA8F;AAClG;;IAEI;QACI,8CAA8C;IAClD;;IAEA;QACI,eAAe;QACf,eAAe;QACf,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;AAEJ;IACI,yCAAyC;IACzC,8BAA8B;IAC9B,+BAA+B;IAC/B,6BAA6B;AACjC;;AAEA;IACI,mDAAmD;IACnD,wCAAwC;IACxC,yCAAyC;IACzC,uCAAuC;AAC3C;;AAEA,WAAW;AACX;IACI,WAAW;IACX,oCAAoC;IACpC,+BAA+B;AACnC;;IAEI;QACI,mBAAmB;QACnB,gBAAgB;IACpB;;;AAGJ;IACI;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA,oBAAoB;AACpB;IACI;QACI,UAAU;QACV,cAAc;IAClB;;IAEA;QACI,kBAAkB;IACtB;;IAEA,2BAA2B;IAC3B;QACI,4BAA4B;IAChC;;IAEA;IACA;AACJ;;AAEA,sBAAsB;AACtB;;IAEI;QACI,gBAAgB;IACpB;;IAEA;IACA;AACJ;;AAEA;;IAEI;QACI,gBAAgB;IACpB;;IAEA;IACA;AACJ;;AAEA;IACI,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,6BAA6B;IAC7B,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,0CAA0C;IAC1C,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,6BAA6B;IAC7B,mCAAmC;AACvC;;AAEA;IACI,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;IAEI;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,uBAAuB;IAC3B;;AAEJ;IACI,kBAAkB;AACtB;;IAEI;QACI,aAAa;QACb,oBAAoB;QACpB,mBAAmB;QACnB,WAAW;IACf;;AAEJ;IACI,kBAAkB;AACtB;;IAEI;QACI,kBAAkB;QAClB,mBAAmB;QACnB,kBAAkB;QAClB,aAAa;QACb,WAAW;IACf;;AAEJ;IACI,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,WAAW;AACf;;AAEA,oDAAoD;;AAEpD;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;AACf","sourcesContent":["@import '../../css/App.css';\r\n/* General layout */\r\n.spa-framework {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100dvh; /* full viewport height (exclusing internal browser  buttons)*/\r\n    width: 100%; /* full width */\r\n    background: var(--color-background);\r\n}\r\n\r\n    .spa-framework.dark {\r\n        background: var(--color-background);\r\n        color: var(--color-foreground);\r\n    }\r\n\r\n    .spa-framework.light {\r\n        background: var(--color-component-background);\r\n        color: var(--color-component-foreground);\r\n    }\r\n\r\n    .spa-framework .spa-header > svg {\r\n        background-color: var(--color-component-transparent-background);\r\n        padding: 0.2rem;\r\n        margin-left: 1rem;\r\n        border-radius: 4px;\r\n    }\r\n\r\n\r\n@media (min-aspect-ratio: 13/9) { /* Very wide viewports (landscape phones) */\r\n    .spa-framework.scrolled-down .spa-header {\r\n        min-height: 0px;\r\n        max-height: 0px;\r\n        opacity: 0;\r\n    }\r\n\r\n    .spa-framework.scrolled-down .spa-sticky-footer {\r\n        min-height: 0px;\r\n        max-height: 0px;\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n.spa-framework > footer {\r\n    flex: 0 0 auto;\r\n    height: fit-content;\r\n}\r\n\r\n.spa-scroll-section-container {\r\n    position: relative;\r\n    display: flex;\r\n    height: 100%;\r\n    margin: 0.5rem;\r\n}\r\n\r\n.spa-scroll-section {\r\n    flex: 1 1 auto; /* fills remaining space */\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n    margin: 0.5rem;\r\n}\r\n\r\n.section-body {\r\n    min-height: 100vh;\r\n    width: 100%;\r\n}\r\n\r\n/* Header */\r\n.spa-header {\r\n    display: flex;\r\n    flex: 0 0 auto;\r\n    align-items: center;\r\n    height: fit-content; /* shrink to content */\r\n    width: 100%;\r\n    position: sticky;\r\n    top: 0;\r\n    z-index: 100;\r\n    transition: opacity ease 0.5s, max-height ease 0.5s, min-height ease 0.5s, transform ease 0.5s;\r\n}\r\n\r\n    .spa-header > svg {\r\n        transition: opacity 1s ease, max-width 1s ease;\r\n    }\r\n\r\n    .spa-header.hidden {\r\n        min-height: 0px;\r\n        max-height: 0px;\r\n        opacity: 0;\r\n    }\r\n\r\n    .spa-header.visible {\r\n        opacity: 1;\r\n    }\r\n\r\n.spa-framework > .spa-header.dark {\r\n    background-color: var(--color-background);\r\n    color: var(--color-foreground);\r\n    stroke: var(--color-foreground);\r\n    fill: var(--color-foreground);\r\n}\r\n\r\n.spa-framework > .spa-header.light {\r\n    background-color: var(--color-component-background);\r\n    color: var(--color-component-foreground);\r\n    stroke: var(--color-component-foreground);\r\n    fill: var(--color-component-foreground);\r\n}\r\n\r\n/* Footer */\r\n.spa-footer {\r\n    width: 100%;\r\n    background: var(--color-footer-back);\r\n    color: var(--color-footer-fore);\r\n}\r\n\r\n    .spa-footer > div {\r\n        height: fit-content;\r\n        min-height: 5rem;\r\n    }\r\n\r\n\r\ndiv.skitterbook-account-header > .account-header-title {\r\n    margin-right: 0.5rem\r\n}\r\n\r\nspan.account-header-error {\r\n    display: none;\r\n}\r\n\r\n/* Mobile (<768px) */\r\n@media (max-width: 767px) {\r\n    .spa-header > svg {\r\n        opacity: 0;\r\n        max-width: 0px;\r\n    }\r\n\r\n    .spa-footer {\r\n        position: relative;\r\n    }\r\n\r\n    /* Header hides on scroll */\r\n    .spa-framework.scrolled-down .spa-header {\r\n        transform: translateY(-100%);\r\n    }\r\n\r\n    .skitterbook-background-image-container {\r\n    }\r\n}\r\n\r\n/* Desktop (>=768px) */\r\n@media (min-width: 768px) {\r\n\r\n    .spa-header {\r\n        min-height: 5rem;\r\n    }\r\n\r\n    .skitterbook-background-image-container {\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n\r\n    .spa-header {\r\n        min-height: 4rem;\r\n    }\r\n\r\n    .skitterbook-background-image-container {\r\n    }\r\n}\r\n\r\n.temporary-body {\r\n    height: 100vh;\r\n    background-color: darkblue;\r\n}\r\n\r\n.scroll-down-indicator {\r\n    position: absolute;\r\n    bottom: 4rem;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    opacity: 0;\r\n    border-radius: 50%;\r\n    z-index: 1;\r\n    transition: opacity 0.5s ease;\r\n    background: var(--color-background);\r\n}\r\n\r\n.scroll-up-indicator {\r\n    position: absolute;\r\n    top: 4rem;\r\n    left: 50%;\r\n    transform: translateX(-50%) rotate(180deg);\r\n    opacity: 0;\r\n    border-radius: 50%;\r\n    z-index: 1;\r\n    transition: opacity 0.5s ease;\r\n    background: var(--color-background);\r\n}\r\n\r\n.spa-framework.can-scroll-down.show-scroll-indicators .scroll-down-indicator {\r\n    opacity: 0.5;\r\n    stroke: var(--color-background);\r\n}\r\n\r\n.spa-framework.can-scroll-up.show-scroll-indicators .scroll-up-indicator {\r\n    opacity: 0.5;\r\n    stroke: var(--color-background);\r\n}\r\n\r\n#framework-top-left, #framework-top-right {\r\n    margin-top: 1rem;\r\n    margin-left: 1rem;\r\n}\r\n\r\n    #framework-top-left > .dock-panel-item > * {\r\n        width: 100%;\r\n        height: 100%;\r\n    }\r\n\r\n    #framework-top-left > .dock-panel-item button {\r\n        width: 100%;\r\n        height: 100%;\r\n        display: flex;\r\n        justify-content: center;\r\n    }\r\n\r\n#framework-top-right {\r\n    width: fit-content;\r\n}\r\n\r\n    #framework-top-right > .dock-panel-item {\r\n        display: flex;\r\n        justify-content: end;\r\n        height: fit-content;\r\n        width: auto;\r\n    }\r\n\r\n.skitterbook-maker-outer-container {\r\n    position: relative;\r\n}\r\n\r\n    .skitterbook-maker-outer-container > .sd-container {\r\n        position: absolute;\r\n        height: fit-content;\r\n        width: fit-content;\r\n        right: 1.5rem;\r\n        top: 1.5rem;\r\n    }\r\n\r\n.skitterbook-background-image-container {\r\n    position: absolute;\r\n    height: 100vh;\r\n    width: 100vw;\r\n    z-index: -1;\r\n}\r\n\r\n/* Add docked gesture swipe containers are smaller */\r\n\r\n.dock-panel-item .gesture-swipe-container {\r\n    height: 2rem;\r\n    width: 2rem;\r\n}\r\n\r\n.dock-panel-item > .skitterbook-live-print-button > span > svg {\r\n    width: 24px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
